import bulletins from './Bulletin';

export default {
  bulletins,
};
